import { Text, ListItem, OrderedList, UnorderedList } from "@chakra-ui/react";
import { map } from "lodash";
import { ImageComponent, VideoComponent } from "./blogComponent";

export function interweaveTransform(node, children) {
  if (node.tagName.toLowerCase() === "ul") {
    return (
      <UnorderedList>
        {map(children, (li, liIdx) => (
          <ListItem key={liIdx} ml={"30px"}>
            {map(li.props.children, (child, childIdx) => (
              <Text key={childIdx} mt="3%" variant="productCardDescription">
                {child}
              </Text>
            ))}
          </ListItem>
        ))}
      </UnorderedList>
    );
  } else if (node.tagName.toLowerCase() === "ol") {
    return (
      <OrderedList>
        {map(children, (li, liIdx) => (
          <ListItem ml={"30px"}>
            {map(li.props.children, (child, childIdx) => (
              <Text mt="3%" variant="productCardDescription">
                {child}
              </Text>
            ))}
          </ListItem>
        ))}
      </OrderedList>
    );
  } else if (node.tagName.toLowerCase() === "h2") {
    return (
      <Text
        mt="5%"
        fontSize={"24px"}
        fontWeight="bold"
        variant="productCardDescription"
      >
        {children}
      </Text>
    );
  } else if (node.tagName.toLowerCase() === "h4") {
    return (
      <Text
        mt="5%"
        fontSize={"18px"}
        fontWeight="bold"
        variant="productCardDescription"
      >
        {children}
      </Text>
    );
  } else if (node.tagName.toLowerCase() === "p") {
    return (
      <Text
        mt={"3%"}
        fontSize={"16px"}
        variant="productCardDescription"
      >
        {children}
      </Text>
    );
  } else if (node.tagName.toLowerCase() === "img") {
    return <ImageComponent src={node.getAttribute("src")} />;
  } else if (node.tagName.toLowerCase() === "iframe") {
    return <VideoComponent src={node.getAttribute("src")} />;
  } else if (node.tagName.toLowerCase() === "figcaption") {
    return null
  }
}
